/**
 * Converts the given number to a string and postfixes it with `px`.
 */
export function px(n: number): string {
  if (!Number.isFinite(n)) {
    return '0px';
  }
  return `${n}px`;
}
